import { Component, effect, inject, Input, OnInit, signal, SimpleChanges } from '@angular/core';
import NotificationService, { NotificationDoc } from '../../services/notification.service';
import { CommonModule, DatePipe } from '@angular/common';
import { catchError, forkJoin, map, of, switchMap, tap } from 'rxjs';
import ClientService from '../../services/client.service';
import { RouterLink } from '@angular/router';
import EmployeeService from '../../services/employee.service';
import CurrentFormService from '../../forms/current_form.service';

@Component({
  selector: 'app-notification-list',
  imports: [CommonModule, DatePipe, RouterLink],
  templateUrl: './notification-list.html',
  styleUrl: './notification-list.css',
})
export class NotificationList implements OnInit {
  @Input() clientUuid: string | null = null;
  @Input()
  count: number = 5;
  private clientService = inject(ClientService);
  private employeeService = inject(EmployeeService);
  private notificationService = inject(NotificationService);
  protected selectedNotification = signal<string>('today');
  notifications$ = signal<
    (NotificationDoc & { employee: any; client: any; formData?: { uuid: string; name: string } })[]
  >([]);
  private currentForm = inject(CurrentFormService);

  ngOnChanges(changes: SimpleChanges) {
    if (changes['clientUuid']) {
      this.loadNotification(this.selectedNotification() as any).subscribe({
        next: (res) => this.notifications$.set(res),
      });
    }
  }

  constructor() {
    effect(() => {
      const client = this.clientService.selectedClient();

      if (client)
        this.loadNotification(this.selectedNotification() as any).subscribe({
          next: (res) => this.notifications$.set(res),
        });
    });
  }

  resetForm() {
    this.currentForm.reset();
  }
  ngOnInit(): void {
    this.selectedNotification.set('today');
    this.loadNotification('today').subscribe({
      next: (res) => {
        this.notifications$.set(res);
      },
    });
  }

  switchNotification(type: 'today' | 'next' | 'done') {
    this.selectedNotification.set(type);
    this.loadNotification(type).subscribe({
      next: (res) => {
        res.length === 0 ? this.notifications$.set([]) : this.notifications$.set(res);
      },
      error: (err) => console.error(err),
    });
  }

  private loadNotification(type: 'today' | 'next' | 'done') {
    return this.notificationService
      .all(this.count, type)
      .pipe(
        switchMap((notifications) => {
          if (notifications.length === 0) return of([]);
          const enrichmentRequests = notifications.map((notif) => {
            if (!notif.payload.clientUuid) {
              return of({ ...notif, client: null });
            }

            return this.clientService.get(notif.payload.clientUuid).pipe(
              map((clientData) => ({
                ...notif,
                client: clientData,
              })),
            );
          });

          return forkJoin(enrichmentRequests);
        }),
      )
      .pipe(
        switchMap((notifications) => {
          if (notifications.length === 0) return of([]);
          const enrichmentRequests = notifications.map((notif) => {
            if (!notif.payload.clientUuid) {
              return of({ ...notif, employee: null });
            }

            return this.employeeService.get(notif.payload.employeeUuid).pipe(
              map((employeeData) => {
                return {
                  ...notif,
                  employee: employeeData[0],
                };
              }),
            );
          });

          return forkJoin(enrichmentRequests);
        }),
      );
  }
}
